module.exports = __webpack_public_path__ + "img/hiw_required_fields_blue.f42bff7b.png";